module.exports = __webpack_public_path__ + "static/wiselogonew-1ad020c81bc1f21d38209d8a9218de39.png";